class ForbiddenPageController {
  constructor() {
  }
}

export default ForbiddenPageController;
